<section class="one-click-panel fx-col fx-gap-3">
  <ng-container [ngSwitch]="phase">

    <!-- Resolving: deciding the initial phase (neutral, no message) -->
    <div
      *ngSwitchCase="'resolving'"
      class="one-click-card fx-col fx-gap-3 p-4 radius-4 border-1 border-grey-100">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>

    <!-- ARM must be updated first -->
    <div
      *ngSwitchCase="'armFirst'"
      class="one-click-card fx-col fx-gap-3 p-3 radius-4 border-1 border-grey-100">
      <customer-title-content
        [title]="labels.oneClickTitle"
        [content]="labels.oneClickArmFirstExplain">
      </customer-title-content>
      <div
        *ngIf="armPlan"
        class="module-row fx-row fx-justify-between fx-center p-2 radius-4 bg-grey-50">
        <span class="tw-font-medium text-grey-400">ARM</span>
        <span class="version-badge">{{ armPlan.currentVersion || '—' }} → {{ armPlan.expectedVersion || '—' }}</span>
      </div>
      <button
        mat-raised-button
        color="accent"
        class="w-full"
        [disabled]="busy"
        (click)="startArmFirst()">
        <mat-icon class="mr-1">system_update</mat-icon>
        {{ labels.oneClickArmFirstCta }}
      </button>
    </div>

    <!-- ARM update in progress -->
    <div
      *ngSwitchCase="'armUpdating'"
      class="one-click-card fx-col fx-gap-3 p-4 radius-4 border-1 border-grey-100">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <div class="text-grey-400 tw-font-medium text-center">{{ labels.oneClickArmUpdating }}</div>
    </div>

    <!-- Ready: one-click all modules -->
    <div
      *ngSwitchCase="'ready'"
      class="one-click-card fx-col fx-gap-3 p-3 radius-4 border-1 border-grey-100">
      <customer-title-content
        [title]="labels.oneClickTitle"
        [content]="labels.oneClickDescription">
      </customer-title-content>
      <div class="fx-col fx-gap-2">
        <div
          *ngFor="let m of modulePlan"
          class="module-row fx-row fx-justify-between fx-center p-2 radius-4 bg-grey-50">
          <span class="tw-font-medium text-grey-400">{{ m.module }}</span>
          <span
            *ngIf="m.module !== 'SAFETY'; else safetyTarget"
            class="version-badge">{{ m.currentVersion || '—' }} → {{ m.expectedVersion || '—' }}</span>
          <ng-template #safetyTarget>
            <span class="version-badge">{{ labels.latestVersion }}</span>
          </ng-template>
        </div>
      </div>
      <button
        mat-raised-button
        color="accent"
        class="w-full"
        [disabled]="busy"
        (click)="startOneClick()">
        <mat-icon class="mr-1">system_update</mat-icon>
        {{ labels.oneClickCta }}
      </button>
    </div>

    <!-- One-click in progress -->
    <div
      *ngSwitchCase="'updating'"
      class="one-click-card fx-col fx-gap-3 p-4 radius-4 border-1 border-grey-100">
      <mat-progress-bar
        [mode]="progressStatus === 3 ? 'determinate' : 'indeterminate'"
        [value]="progressValue">
      </mat-progress-bar>
      <div class="fx-row fx-center fx-gap-2">
        <mat-icon class="text-accent spin s-5">sync</mat-icon>
        <span class="text-grey-400 tw-font-medium">{{ statusLabel(progressStatus, progressValue) }}</span>
      </div>
    </div>

    <!-- Success -->
    <div
      *ngSwitchCase="'success'"
      class="p-3 text-center text-grey-400 w-full bg-green-100 border-1 radius-4 border-green-100">
      {{ labels.oneClickSuccess }}
    </div>

    <!-- Failed -->
    <div
      *ngSwitchCase="'failed'"
      class="fx-col fx-gap-3">
      <div class="p-3 text-center text-grey-400 w-full bg-red-100 border-1 radius-4 border-grey-100">
        {{ labels.oneClickFailed }}
      </div>
      <button
        mat-button
        class="w-full"
        [disabled]="busy"
        (click)="retry()">
        <mat-icon class="mr-1">refresh</mat-icon>
        {{ labels.oneClickRetry }}
      </button>
    </div>

    <!-- Blocked: cannot update remotely -->
    <div
      *ngSwitchCase="'blocked'"
      class="p-3 text-center text-grey-400 w-full bg-yellow-100 border-1 radius-4 border-grey-100">
      {{ labels.oneClickBlocked }}
    </div>

    <!-- Unknown: support-types unavailable -->
    <div
      *ngSwitchCase="'unknown'"
      class="fx-col fx-gap-3">
      <div class="p-3 text-center text-grey-400 w-full bg-yellow-100 border-1 radius-4 border-grey-100">
        {{ labels.oneClickUnknown }}
      </div>
      <button
        mat-button
        class="w-full"
        [disabled]="busy"
        (click)="retry()">
        <mat-icon class="mr-1">refresh</mat-icon>
        {{ labels.oneClickRetry }}
      </button>
    </div>

  </ng-container>
</section>
